const monitoring = (PROGRAMS) => {
    const block = document.getElementById('monitoring');

    if (!block) {
        return;
    }

    /* Вывод данных */
    (() => {
        const loader = document.querySelector('.monitoring__loader');
        loader.classList.remove('active');
        
        let wrap = document.createElement('div');
        wrap.classList.add('monitoring__wrap');
        wrap.append(createList(PROGRAMS.programs));
        block.append(wrap); 
    })()

    /* Создание таблицы с данными */
    function createList(data) {        
        const block = document.createElement('div'),
            tbodyOnline = document.createElement('tbody'),
            tbodyOfflinePrograms = document.createElement('tbody');
        
        block.classList.add('monitoring__block');

        if (data.length < 1) {
            block.innerHTML = `
                <p style="font-size: 20px; color: #E30016; text-align: center; font-weight: 700">Нет доступных программ!</p>
            `
        } else {
            data.forEach(function (elem) {
                const {name, shortname, level, educational_form, program_group_id} = elem;
                const block = document.createElement('tr');  
                
                block.innerHTML += `
                        <td style="color: #3052d8; font-family: 'Proxima Nova - Semibold', sans-serif;">${name}</td>
                        <td>${program_group_id}</td>
                        <td>${level == 'additional_vocational' ? 'ДПО' : 'ПО'}</td>
                        <td>${shortname}</td>
                `
                
                /* Вставляем программы с редиректом в начало */
                if (educational_form == "online") {
                    tbodyOnline.append(block);
                } else {
                    tbodyOfflinePrograms.append(block)
                }
            });
    
            block.innerHTML = `
                <h3>Количество программ - ${data.length}</h3>
                <h4>Онлайн программы</h4>
                <table>
                    <thead>
                        <tr>
                            <td>Название</td>
                            <td>program_group_id</td>
                            <td>Level</td>
                            <td>Url</td>
                        </tr>
                    </thead>
                    ${tbodyOnline.innerHTML}
                </table>
                <br><br><br>
                <h4>Офлайн программы</h4>
                <table>
                    <thead>
                        <tr>
                            <td>Название</td>
                            <td>program_group_id</td>
                            <td>Level</td>
                            <td>Url</td>
                        </tr>
                    </thead>
                    ${tbodyOfflinePrograms.innerHTML}
                </table>
            `
        }

        return block;
    }
}

export default monitoring;